var exports = {
  "k": "x804f0401--93541a--container",
};

module.exports = exports;
